export default (window as any).Routing;
